module.exports = __webpack_public_path__ + "img/Thumbnails_Deliver.60f89a1d.jpg";